/*
    Create by fanglijuan 2016-05-23
*/
'use strict';
angular.module("userMngGroupMngSortGroupModule", [])
    .controller("userMngGroupMngSortGroupCtrl", ["$scope", "trsHttpService", '$http', '$modalInstance', "$validation", "trsspliceString", "groupManageMentService", "sortGroupInfo",
        function($scope, trsHttpService, $http, $modalInstance, $validation, trsspliceString, groupManageMentService, sortGroupInfo) {
            initStatus();
            initData();
            /**
             * [initStatus description]初始化参数
             */
            function initStatus() {
                $scope.data = {
                    modalTitle: sortGroupInfo.modalTitle,
                    GroupId: sortGroupInfo.GroupId,
                    ParentId: sortGroupInfo.ParentId,
                    itemcount: sortGroupInfo.itemcount,
                    GName: sortGroupInfo.GName,
                    curPos:sortGroupInfo.curPos,
                    showInp:false
                };
                $scope.status = {
                    modalTitle: "调整顺序",
                    sortOptions : [{
                        name: "最前",
                        value: 1
                    }, {
                        name: "最后",
                        value: sortGroupInfo.itemcount
                    }, {
                        name: "指定位置",
                        value: ""
                    }],
                    sortOptionSelected:[]                   
                };
                $scope.status.sortOptionSelected.push($scope.status.sortOptions[0]);
            }
            /**
             * [initData description]初始化数据
             */
            function initData() {}
            //确定
            /**
         * [queryByDropdown description] 筛选条件触发后请求数据(下拉框选择：最前面，最后面，指定位置)
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function(index) {
            if(index==2){
                $scope.data.showInp=true;
            }else{
                $scope.data.showInp=false;
            };
            $scope.status.sortOptionSelected=[];
            $scope.status.sortOptionSelected.push($scope.status.sortOptions[index]);                             
        };
            $scope.confirm = function() {
                $validation.validate($scope.sortGroupSubmitForm).success(function() {
                    if(!$scope.data.showInp){
                        $scope.data.NewOrder=$scope.status.sortOptionSelected[0].value;
                    }
                    if ($scope.data.NewOrder > sortGroupInfo.itemcount) {
                        $scope.data.NewOrder = sortGroupInfo.itemcount;
                    }
                    var params = {
                        "serviceid": "mlf_groupmanagement",
                        "methodname": "sortSetUpGroup",
                        "FromGroupId": sortGroupInfo.GroupId,
                        "NewOrder": $scope.data.NewOrder,
                        "ParentId": sortGroupInfo.ParentId
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                        $modalInstance.close();
                    });
                });
            };
            //取消
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };

        }
    ]);